import { render, staticRenderFns } from "./ClientInvoicesTable.vue?vue&type=template&id=382fc5c5&scoped=true"
import script from "./ClientInvoicesTable.vue?vue&type=script&lang=js"
export * from "./ClientInvoicesTable.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=382fc5c5&prod&scoped=true&lang=css&external"
import style1 from "./ClientInvoicesTable.vue?vue&type=style&index=1&id=382fc5c5&prod&scoped=true&lang=css"
import style2 from "@/assets/styles/beneficiary.css?vue&type=style&index=2&id=382fc5c5&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382fc5c5",
  null
  
)

export default component.exports